var _clipPath, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBritish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 30",
    width: 50,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,15h25v15zv15h-25zh-25v-15zv-15h25z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v30h50v-30z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 50,30M50,0 0,30",
    stroke: "#fff",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 50,30M50,0 0,30",
    clipPath: "url(#t)",
    stroke: "#C8102E",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 11h22v-12h8v12h22v8h-22v12h-8v-12h-22z",
    fill: "#C8102E",
    stroke: "#FFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritish);
export default __webpack_public_path__ + "static/media/british.0a9e2907d98156ea7accf899299706f2.svg";
export { ForwardRef as ReactComponent };